import * as actionTypes from "../constants/actionTypes";
import * as config from "../constants/config";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";
import * as getActions from "./getActions";

export const ticketingTabInit = (tabId) => ({
    type: actionTypes.TICKETING_TAB_INIT,
    payload: {
        tabId: tabId
    }
});

export const tmcAvailable = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_TMC_CONNECTION_STATUS
    },
    method: handlers.GET_TMC_CONNECTION_STATUS,
    tabId: 0
});

export const createTicket = (ticket, version) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_CREATE_TICKET,
        params: {
            ...ticket,
            customer: ticket.customer?.formatedObject() ?? null,
            fandeck: ticket.fandeck?.formatedObject() ?? null,
            color: ticket.color?.formatedObject() ?? null,
            product: ticket.product?.formatedObject() ?? null,
            base: ticket.base?.formatedObject() ?? null,
            department: ticket.department?.formattedObject() ?? null,
            version: version
        }
    },
    method: handlers.CREATE_TICKET,
    tabId: 0
});

const getFormulaCombinationFromJsonAttributes = (formula) => {
    try {
        return {
            product: formula.product,
            fandeck: formula.fandeck,
            color: formula.color,
            base: formula.base,
            colorants: formula.colorants
                .filter((colorant) => colorant.amount !== null)
                .map((colorant) => colorant.colorantName)
        };
    } catch (e) {
        return null;
    }
};

export const checkAndAddCustomFormulaFromXml = (tabId, xmlData, formula, ticketId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_CHECK_CUSTOM_FORMULA_FROM_XML,
        params: {
            xmlData: xmlData
        }
    },
    method: handlers.CHECK_AND_ADD_CUSTOM_FORMULA_FROM_XML,
    tabId: tabId,
    next: {
        type: actionTypes.SERVER_REQUEST,
        payload: {
            type: methods.METHOD_ADD_CUSTOM_FORMULA_FROM_XML,
            params: {
                xmlData: xmlData,
                ticketId: ticketId
            }
        },
        method: handlers.ADD_CUSTOM_FORMULA_FROM_XML,
        tabId: tabId,
        next: getFormulaCombinationFromJsonAttributes(formula)
    }
});

export const getTickets = (tabId = 0, rowCount = config.MAX_TICKET_LIMIT, offset = 0) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_TICKETS,
        params: {
            orderBy: null,
            asc: true,
            rowCount: rowCount,
            offset: offset
        }
    },
    method: handlers.GET_TICKETS,
    tabId: tabId
});

export const markTicketAsRead = (id) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_MARK_TICKET_AS_READ,
        params: {
            id: id
        }
    },
    method: handlers.MARK_TICKET_AS_READ,
    tabId: 0
});

export const getServiceDepartments = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_SERVICE_DEPARTMENTS
    },
    method: handlers.GET_SERVICE_DEPARTMENTS,
    tabId: 0
});

export const getFandeckList = (colorId = null, fandeckName = null) =>
    getActions.getFandecksByParams(
        null,
        null,
        colorId,
        null,
        fandeckName,
        false,
        false,
        false,
        false,
        handlers.TICKETING_GET_FANDECK_LIST,
        null
    );

export const getColorList = (fandeckId = null, colorName = null) =>
    getActions.getColorsByParams(
        null,
        null,
        fandeckId,
        null,
        colorName,
        null,
        false,
        false,
        false,
        false,
        handlers.TICKETING_GET_COLOR_LIST,
        null
    );

export const getProductList = (baseName = null, productName = null) =>
    getActions.getProductsByParams(
        null,
        null,
        null,
        baseName,
        productName,
        false,
        false,
        false,
        false,
        handlers.TICKETING_GET_PRODUCT_LIST
    );

export const getBaseList = (productId = null, baseName = null) =>
    getActions.getBasesByParams(
        null,
        productId,
        null,
        null,
        baseName,
        false,
        false,
        handlers.TICKETING_GET_BASE_LIST,
        null,
        null
    );

export const deleteTicket = (id) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_DELETE_TICKET,
        params: {
            ticket_ids: [id]
        }
    },
    method: handlers.DELETE_TICKET,
    tabId: 0
});
